import { render } from "./App.vue?vue&type=template&id=222e2dfe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=222e2dfe&lang=less"

import exportComponent from "/Users/yulian/DEVELOPMENT/g2-rtf-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__